export default {
  'pages.zuzhijiegou': '組織構成',
  'pages.xinjiangongsi': '新規会社作成',
  'pages.xinjianbumen': '新規部署作成',
  'pages.xinjianchengyuan': '新規メンバー作成',
  'pages.jibenziliao': '基本情報',
  'pages.chengyuanliebiao': 'メンバーリスト',
  'pages.gongsimingcheng': '会社名',
  'pages.gongsimiaoshu': '会社概要説明',
  'pages.zuihougengxinyu': '最終更新日',
  'pages.tijiaobingbaocungenggai': '変更を保存して提示',
  'pages.xingming': '名前',
  'pages.xingbie': '性別',
  'pages.zhuangtai': 'ステータス',
  'pages.dengluming': 'ログイン名',
  'pages.caozuo': '操作',
  'pages.bianji': '編集',
  'pages.shanchu': '削除',
  'pages.queding': '確認',
  'pages.quxiao': 'キャンセル',
  'pages.bumen': '部署',
  'pages.jueseguanli': 'ロール管理',
  'pages.jueseliebiao': 'ロールリスト',
  'pages.xinzengjuese': '新規ロール作成',
  'pages.bianjijuese': 'ロール編集',
  'pages.sousuo': '検索',
  'pages.xuhao': '番号',
  'pages.juesemingcheng': 'ロール名',
  'pages.quanxianxinxi': '権限情報',
  'pages.chengyuanshuliang': 'メンバー数',
  'pages.chengyuan': 'メンバー',
  'pages.suoshugongsi': '所属会社',
  'pages.quanxianxiang': '権限項目',
  'pages.chengyuanguanli': 'メンバー管理',
  'pages.leixing': 'タイプ',
  'pages.duixiang': '対象',
  'pages.xinzengchengyuan': '新規メンバー',
  'pages.bianjichengyuan': 'メンバー編集',
  'pages.gongsi': '会社',
  'pages.yichu': '削除',
  'pages.quanxianmingcheng': '権限名称',
  'pages.quanxianmiaoshu': 'アクセス権概要',
  'pages.api': 'APIインターーフェース',
  'pages.miyaoxinxi': 'キー情報',
  'pages.jiekoumingcheng': 'インタフェース名',
  'pages.qingqiufangfa': 'リクエスト方法',
  'pages.jiekoudizhi': 'インタフェースアドレス',
  'pages.jiekoumiaoshu': 'インタフェース概要説明',
  'pages.miyaomingcheng': 'キー名称',
  'pages.miyaoxinxi': 'キー情報',
  'pages.miaoshu': '概要',
  'pages.xiugaimima': 'パスワードを変更する',
  'pages.jiumima': '旧パスワード',
  'pages.xinmima': '新パスワード',
  'pages.querenxinmima': '新パスワードの確認',
  'pages.querenxiugai': '変更の確認',
  'pages.mobanguanli': 'テンプレート管理',
  'pages.tishicimoban': 'プロンプトテンプレート',
  'pages.pptmoban': 'PPTテンプレート',
  'pages.xinzengmoban': '新規テンプレート作成',
  'pages.mobanmingcheng': 'テンプレート名',
  'pages.shijian': '時間',
  'pages.bianjimoban': 'テンプレート編集',
  'pages.tishicineirong': 'プロンプト内容設定',
  'pages.shangchuanmoban': 'テンプレートファイルアップロード',
  'pages.shangchuanwenjian': 'ファイルをアップロードする',
  'pages.uploadmsg': 'PPTファイルをアップロードしてください。サイズは100 M以内です',
  'pages.yongyuji': '用語集',
  'pages.xinzeng': '新規作成',
  'pages.daoru': 'インポート',
  'pages.daochu': 'エクスポート',
  'pages.zhongwen': '中国語',
  'pages.riwen': '日本語',
  'pages.yingyu': '英語',
  'pages.hanyu': '韓国語',
  'pages.yueyu': '広東語',
  'pages.xinzengyongyudui': '新規用語作成',
  'pages.bianjiyongyudui': '既存用語編集',
  'pages.xinzengshuyu': '新規術語作成',
  'pages.bianjishuyu': '術語編集',
  'pages.renliziyuan': 'ヒューマンリソース',
  'pages.logintitle': 'ようこそ',
  'pages.zhanghao': 'アカウント',
  'pages.mima': 'パスワード',
  'pages.yonghuming': 'ユーザー名',
  'pages.youxiang': 'メールボックス',
  'pages.chuangjianshijian': '作成日時',
  'pages.tuichudenglu': 'ログアウト',
  'pages.shangjibumen': '上級部署',
  'pages.bumenmingcheng': '部署名',
  'pages.bumenmiaoshu': '部署説明',
  'pages.nan': '男性',
  'pages.nv': '女性',
  'pages.zaizhi': '在職',
  'pages.lizhi': '退職',
  'pages.querenshanchuma': '削除を確認されますか？',
  'pages.shanchutixing': '削除リマインド',
  'pages.permission_name1': '組織構成メンテナンス',
  'pages.permission_desc1': '部署、メンバーの確認/新規作成/編集/無効化を許可',
  'pages.permission_name2': 'ロールメンテナンス',
  'pages.permission_desc2': '表示/新規/編集/確認/新規作成/編集/削除可',
  'pages.permission_name3': 'アクセス権項目確認',
  'pages.permission_desc3': 'アクセス権項目一覧確認',
  'pages.permission_name4': '会議リアルタイム翻訳',
  'pages.permission_desc4': '会議リアルタイム翻訳機能モジュール使用を許可',
  'pages.permission_name5': 'ドキュメントインテリジェント処理',
  'pages.permission_desc5': 'ドキュメントインテリジェント処理機能モジュール使用を許可',
  'pages.permission_name6': 'コンテンツ自動生成',
  'pages.permission_desc6': 'コンテンツ自動生成機能モジュール使用を許可',
  'pages.permission_name7': 'テンプレートメンテナンス',
  'pages.permission_desc7': '表示/新規/編集/確認/新規作成/編集/削除可',
  'pages.permission_name8': '用語集メンテナンス',
  'pages.permission_desc8': '確認/新規作成/編集/削除可',
  'pages.permission_name9': '監査ログ確認',
  'pages.permission_desc9': '監査ログ確認を許可',
  'pages.permission_name10': 'APIキーメンテナンス',
  'pages.permission_desc10': 'APIキーの確認/編集可',
  'pages.permission_name11': 'ホットワードメンテナンス',
  'pages.permission_desc11': '確認/新規作成/削除可',
  'pages.permission_name12': '術語介入メンテナンス',
  'pages.permission_desc12': '確認/新規作成/編集/削除可',
  'pages.permission_name13': '統計レポート確認',
  'pages.permission_desc13': '会議の高評価・低評価レポートを確認可能',
  'pages.permission_name14': 'バージョン設定メンテナンス',
  'pages.permission_desc14': '各アプリモジュールのバージョン設定を確認/編集可能',
  'pages.permission_name15': '会議テーマ制限',
  'pages.permission_desc15': '会議テーマの長さ制限を確認/編集できます',
  'pages.shangchuanchenggong': 'アップロード成功',
  'pages.shangchuanshibai': 'アップロード失敗',
  'pages.mobantixing': 'テンプレートインポート中で、しばらくお待ち下さい...',
  'pages.zhongguoluosen': 'ローソン中国',
  'pages.guanjianci': 'キーワード',
  'pages.pptuploadmsg': 'アップロード対象ファイルはxlsx ファイル形式であることごを確認お願い致します',
  'pages.gonghao': '社員番号',
  'pages.shouji': '携帯電話',
  'pages.weihuren': '編集者',
  'pages.yuanwenjian': 'ファイルロケーション',
  'pages.shengchengwenjian': 'ファイル生成',
  'pages.caozuoren': 'オペレータ',
  'pages.isPPT': 'pptファイルのみアップロード可能',
  'pages.20M': '最大100 M対応',
  'pages.isXLSX': 'xlsxファイルのみアップロード可能',
  'pages.shoujiguize': '正しい携帯番号を入力してください',
  'pages.gongsimingchengyicunzai': '会社名はすでに存在しています',
  'pages.bumenmingchengyicunzai': '部門名はすでに存在しています',
  'pages.denglumingyicunzai': 'ログイン名はすでに存在しています',
  'pages.youxiangyicunzai': 'メールボックスはすでに存在しています',
  'pages.shoujiyicunzai': '携帯電話はすでに存在しています',
  'pages.gonghaoyicunzai': '製造番号はすでに存在しています',
  'pages.juesemingchengyicunzai': 'ロール名はすでに存在します',
  'pages.yicunzai': '既に存在する',
  'pages.pwd_expired_days': 'パスワード有効期間',
  'pages.pwd_length_min': 'パスワードミニマム桁数',
  'pages.pwd_length_max': 'パスワードMAX桁数',
  'pages.pwd_complexity': 'パスワード複雑性',
  'pages.lock_error_num': '入力間違いロックアウト回数',
  'pages.lock_error_minutes': 'ロックアウト時間',
  'pages.buxianzhi': '制限なし',
  'pages.fuza': '大文字、小文字、数字、特殊符合の4種類組み合わせが必須',
  'pages.yanzhengma': '認証コード',
  'pages.getyanzhengma': '認証コードを取得',
  'pages.okyanzhengma': '認証コードの送信に成功しました',
  'pages.failyanzhengma': '認証コードの送信に失敗しました',
  'pages.tian': '天',
  'pages.wei': 'ビット',
  'pages.ci': '次',
  'pages.fenzhong': '分',
  'pages.null': 'スペースの入力禁止',
  'pages.confirmpwd': 'パスワードエラーの確認',
  'pages.loginusername': '管理プラットフォームにログインするアカウント',
  'pages.loginpwd': '管理プラットフォームにログインするアカウントのパスワード',
  'pages.code_expired': '認証コード間違いまたは有効期限切れ',
  'pages.login_error1': 'アカウントまたはパスワードが間違っている',
  'pages.login_error2': 'パスワードの有効期限が切れました。パスワード忘れでリセットしてください',
  'pages.error_more1': 'エラー回数が超過しました',
  'pages.error_more2': '回、アカウントがロックされました。パスワード忘れでリセットしてください。またはロックが解除されるのをお待ち下さい。',
  'pages.error_more3': '分後に再試行',
  'pages.xiugaichenggong': '変更成功',
  'pages.shanchuchenggong': '削除成功',
  'pages.yicunzai': '重複用語集が存在しております。',
  'pages.gaizuzhineimeiyouyonghu': '組織内にユーザーが1名もいません',
  'pages.mobanmingchengyicunzai': 'テンプレート名はすでに存在します',
  'pages.moban_scope': 'テンプレート範囲',
  'pages.gonggongmoban': '共通テンプレート',
  'pages.gongsimoban': '会社テンプレート',
  'pages.baohanxiashugongsi': '子会社を含む',
  'pages.shiyongxiashugongsi': '子会社にも適用',
  'pages.qingxuanzegongsi': '所属会社を選択してください',
  'pages.xiazai': 'ダウンロード',
  'pages.gonggong': '共通',
  'pages.geren': '個人',
  'pages.cunzaibumenchengyuan': '削除できない部署またはメンバーが存在しています',
  'pages.cunzaichengyuan': 'メンバーが存在し、削除できません',
  'pages.xiazaimoban': 'テンプレートのダウンロード',
  'pages.suijishengcheng': 'ランダム生成',
  'pages.zonggong': '合計',
  'pages.tiao': '条',
  'pages.chongzhi': 'リセット',
  'pages.huiyizhuti': '会議テーマ',
  'pages.yuyanzuhe': '言語設定',
  'pages.huiyishijian': '会議日時',
  'pages.fankuileixing': 'フィードバック種別',
  'pages.fankuiyuanyin': 'フィードバック理由',
  'pages.fankuishijian': 'フィードバック日時',
  'pages.sucaiyulan': '素材プレビュー',
  'pages.sucaimingcheng': '素材名',
  'pages.sucailujing': '素材パス',
  'pages.xinzengsucai': '素材を新規作成',
  'pages.bianjisucai': '素材を編集',
  'pages.tongleixingzhinengqiyongyitiao': '同じフィードバック種別で有効にできる素材は1件のみです',
  'pages.qiyong': '有効',
  'pages.tingyong': '無効',
  'pages.paixu': '並び順',
  'pages.zan': '高評価',
  'pages.cai': '低評価',
  'pages.jiazaishibai': '読み込み失敗',
  'pages.baocunchenggong': '保存成功',
  'pages.baocunshibai': '保存失敗',
  'pages.yiyingyong': '適用済み',
  'pages.bianjibanben': 'バージョン編集',
  'pages.yingyongmingcheng': 'アプリ名',
  'pages.banbenhao': 'バージョン番号',
  'pages.meetingTopicLimitTitle': '会議テーマ制限',
  'pages.meetingTopicLimitEnable': 'ルールを有効にする',
  'pages.meetingTopicLimitZh': '中国語文字数上限',
  'pages.meetingTopicLimitEn': '英字数上限',
  'pages.meetingTopicLimitDigit': '数字上限',
  'pages.meetingTopicLimitOther': 'その他文字数上限',
  'pages.meetingTopicLimitTotal': '総文字数上限',
  'pages.meetingTopicLimitBytesHint': '総長は {bytes} bytes を超えられません。未入力は制限なしです。',
  'pages.meetingTopicLimitNoticeZh': '中国語の案内文',
  'pages.meetingTopicLimitNoticeZhPlaceholder': '空欄の場合はシステムの中国語デフォルト案内を使用します',
  'pages.meetingTopicLimitNoticeJa': '日本語の案内文',
  'pages.meetingTopicLimitNoticeJaPlaceholder': '空欄の場合はシステムの日本語デフォルト案内を使用します',
  'pages.meetingTopicLimitSave': '設定を保存',
  'pages.meetingTopicLimitDisabled': '現在はルールが有効ではありません',
  'pages.faburiqi': 'リリース日',
  'pages.kaiqi': 'オン',
  'pages.guanbi': 'オフ',
  'pages.shifouxianshibanben': 'バージョン番号を表示',
  'pages.fabuxinbanben': '新バージョンをリリース',
  'pages.fabuchenggong': 'リリース成功',
  'pages.lishibanben': '履歴バージョン',
  'pages.zanwulishibanben': '履歴バージョンはありません',
  'pages.zuixinneirong': '最新更新内容',
  'pages.zanwugengxinneirong': '更新内容はありません',
  'pages.gongnengqingdan': '機能リスト',
  'pages.qingshurugongnengqingdan': '機能リストを入力してください',
  'pages.gongnengqingdanplaceholder': '今回のリリースで更新した機能リストを入力してください。1行1件を推奨します',
  'pages.updateHot': 'ホットワード更新',
  'pages.hotname': 'ホットワード名',
  'pages.hotTips': 'ヒント：複数のヒントは英語のカンマでつなげる。',
  'pages.AI_API_KEY': '千問大モデルApiKey',
  'pages.AI_WORKSPACE_ID': '百煉業務スペースID',
  'pages.AI_KB_ID': 'ナレッジベースID',
  'pages.AL_KEY_ID': '阿里云aceess_key_id',
  'pages.AL_KEY_SECRET': '阿里云aceess_key_secret',
  'pages.QIWEI_ID': '企業微信ID',
  'pages.QIWEI_SECRET': 'リアルタイム会議アプリのキー',
  'pages.QIWEI_SECRET2': '文書インテリジェント処理キー',
  'pages.QIWEI_SECRET': 'コンテンツ生成キー',


  'pages.layouts.userLayout.title': 'システムのバックグラウンドにアクセスするための資格証明を入力してください',
  'pages.login.accountLogin.tab': 'アカウントログイン',
  'pages.login.accountLogin.errorMessage':
    'ユーザー名/パスワードが正しくありません(admin/ant.design)',
  'pages.login.failure': 'ログインに失敗したら、もう一度試してください!',
  'pages.login.success': 'ログイン成功!',
  'pages.login.username.placeholder': 'ユーザー名：adminまたはuser',
  'pages.login.username.required': 'ユーザー名を入力してください！',
  'pages.login.password.placeholder': 'パスワード：ant.design',
  'pages.login.password.required': 'パスワードを入力してください！',
  'pages.login.phoneLogin.tab': '電話ログイン',
  'pages.login.phoneLogin.errorMessage': '検証コードエラー',
  'pages.login.phoneNumber.placeholder': '電話番号',
  'pages.login.phoneNumber.required': '電話番号を入力してください！',
  'pages.login.phoneNumber.invalid': '電話番号が無効です！',
  'pages.login.captcha.placeholder': '確認コード',
  'pages.login.captcha.required': '確認コードを入力してください！',
  'pages.login.phoneLogin.getVerificationCode': '確認コードを取得',
  'pages.getCaptchaSecondText': '秒',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'パスワードをお忘れですか？',
  'pages.login.submit': 'ログイン',
  'pages.login.loginWith': 'その他のログイン方法：',
  'pages.login.registerAccount': 'アカウント登録',
  'pages.welcome.link': 'ようこそ',
  'pages.welcome.alertMessage':
    'より高速で強力な頑丈なコンポーネントがリリースされました。',
  'pages.404.subTitle':
    '申し訳ありませんが、アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホームに戻る',
  'pages.admin.subPage.title': 'このページは管理者のみが表示できます',
  'pages.admin.subPage.alertMessage':
    'Umi uiがリリースされました。npm run uiを使用して体験してください。',
  'pages.searchTable.createForm.newRule': '新しいルール',
  'pages.searchTable.updateForm.ruleConfig': 'ルール構成',
  'pages.searchTable.updateForm.basicConfig': '基本情報',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'ルール名',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'ルール名を入力してください！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'ルールの説明',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    '5文字以上入力してください',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '5文字以上のルールの説明を入力してください！',
  'pages.searchTable.updateForm.ruleProps.title': 'プロパティの構成',
  'pages.searchTable.updateForm.object': '監視対象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'ルールテンプレート',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'ルールタイプ',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'スケジュール期間の設定',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '開始時間を選択してください！',
  'pages.searchTable.titleDesc': '説明',
  'pages.searchTable.ruleName': 'ルール名が必要です',
  'pages.searchTable.titleCallNo': 'サービスコール数',
  'pages.searchTable.titleStatus': 'ステータス',
  'pages.searchTable.nameStatus.default': 'デフォルト',
  'pages.searchTable.nameStatus.running': '起動中',
  'pages.searchTable.nameStatus.online': 'オンライン',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '最終スケジュール',
  'pages.searchTable.exception': '例外の理由を入力してください！',
  'pages.searchTable.titleOption': 'オプション',
  'pages.searchTable.config': '構成',
  'pages.searchTable.subscribeAlert': 'アラートを購読する',
  'pages.searchTable.title': 'お問い合わせフォーム',
  'pages.searchTable.new': '新しい',
  'pages.searchTable.chosen': '選んだ項目',
  'pages.searchTable.item': '項目',
  'pages.searchTable.totalServiceCalls': 'サービスコールの総数',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': 'バッチ削除',
  'pages.searchTable.batchApproval': 'バッチ承認',
  'pages.geshicuowu': 'ファイル形式が間違っています',
  'pages.uploadpic': 'jpg、png画像をアップロードしてください',
  'pages.gonghaoemail': 'パスワード変更',
  'pages.queren': '確認',
  'pages.yuyan': '言語'
};
